// в константы выносим только названия мутаций/свойств,
// которые переиспользуем/планируем переиспользовать
export const NOTIFICATION_CREATE = 'NOTIFICATION_CREATE';
export const NOTIFICATION_DELETE = 'NOTIFICATION_DELETE';
export const NOTIFICATION_TYPE_SUCCESS = 'NOTIFICATION_TYPE_SUCCESS';
export const NOTIFICATION_TYPE_ERROR = 'NOTIFICATION_TYPE_ERROR';
export const NOTIFICATION_TYPE_INFO = 'NOTIFICATION_TYPE_INFO';
export const NOTIFICATION_TYPE_WARNING = 'NOTIFICATION_TYPE_WARNING';
export const NOTIFICATION_TYPE_MESSAGE = 'NOTIFICATION_TYPE_MESSAGE';

const store = {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    NOTIFICATION_CREATE(state, {
      type,
      body,
      title,
      duration,
      temporaryId,
    }) {
      const notification = {
        date: Date.now(),
        type,
        body,
        title: title || `#${type}`,
        duration: duration || 2000,
        temporaryId,
      };

      const isExist = state.list.find((item) => item.temporaryId !== null && item.temporaryId === temporaryId
        && item.title === title && item.body === body);

      if (isExist) return;

      state.list.push(notification);
    },
    NOTIFICATION_DELETE(state, notification) {
      const idx = state.list.indexOf(notification);
      if (idx !== -1) {
        state.list.splice(idx, 1);
      }
    },
  },
};

export default store;
